import { createHeaderLogo, LogoProps } from './createHeaderLogo'
import { StyledImageLogo } from '../TheWestHeader.styled'

const logoFile: string = require('./images/masthead-albany-advertiser.png')

const props: LogoProps = {
    alt: 'Albany Advertiser',
    src: logoFile,
    heights: {
        desktop: 82,
        tablet: 70,
        mobile: 50,
    },
    ampInitialSize: {
        width: 618,
        height: 92,
    },
    verticalSpacing: 4,
}

export default createHeaderLogo(StyledImageLogo, props)
